import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IAccountInterface } from './account.interface';

@Injectable({
	providedIn: 'root',
})
export class AccountState {
	private accounts$: BehaviorSubject<IAccountInterface[]> = new BehaviorSubject<IAccountInterface[]>([]);
	private updating$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor() {}

	isUpdating$() {
		return this.updating$.asObservable();
	}

	setUpdating(isUpdating: boolean) {
		this.updating$.next(isUpdating);
	}

	getAccounts(): Observable<IAccountInterface[]> {
		return this.accounts$.asObservable();
	}

	getAccountsValue(): IAccountInterface[] {
		return this.accounts$.getValue();
	}

	setAccounts(accounts: IAccountInterface[]) {
		return this.accounts$.next(accounts);
	}

	renameAccount(updatedAccount: IAccountInterface) {
		const accounts = this.accounts$.getValue();
		const indexOfUpdated = accounts.findIndex((a) => a.id === updatedAccount.id);
		accounts[indexOfUpdated] = updatedAccount;
		this.accounts$.next([...accounts]);
	}
}
